var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentScene,{tag:"component",attrs:{"mode":_vm.mode},on:{"wxPreview":_vm.wxPreview}})}
var staticRenderFns = []

export { render, staticRenderFns }